<template>
	<div class="search-filters">
		<div class="color-violet fs-18 lh-24 fw-700">Adjust Search Criteria</div>
		<div class="grid gap-32 mt-24" :class="{'show-xxl': collapsed}">
			<TextField v-model="name" @change="onChange">Name</TextField>

			<ExperienceField v-model="experience" class="experience" placeholder="Any" @change="onChange" />

			<FieldGroup class="cost-range" label="Cost per Hour">
				<NumberField v-model="costPerHourFrom" type="USD" :min="0" @change="onChange" />
				<span>to</span>
				<NumberField v-model="costPerHourTo" type="USD" :min="costPerHourFrom" @change="onChange" />
			</FieldGroup>

			<RatingField v-model="rating" @change="onChange">
				<span class="color-violet fs-16 lh-16 fw-700">Minimum Rating</span>
			</RatingField>

			<TagFieldAlt v-model="badges" type="Badge" @change="onChange" />
			<TagFieldAlt v-model="certificationBadges" type="Certification" @change="onChange" />
			<TagFieldAlt v-model="communityBadges" type="Community" @change="onChange" />
			<TagFieldAlt v-model="skills" type="skill" @change="onChange" />
			<TagFieldAlt v-model="gear" type="gear" @change="onChange" />
			<TagFieldAlt v-model="languages" type="language" @change="onChange" />
		</div>
	</div>
</template>

<script>
export default {
  name: 'JobFilters',
  props: {
	collapsed: {
		default: false,
	},
  },
  computed: {
    awardBadges: {
      get() {
        return this.filters.awardBadges;
      },
      set(value) {
        this.setFilter('awardBadges', value);
      },
    },
    badges: {
      get() {
        return this.filters.badges;
      },
      set(value) {
        this.setFilter('badges', value);
      },
    },
    certificationBadges: {
      get() {
        return this.filters.certificationBadges;
      },
      set(value) {
        this.setFilter('certificationBadges', value);
      },
    },
    communityBadges: {
      get() {
        return this.filters.communityBadges;
      },
      set(value) {
        this.setFilter('communityBadges', value);
      },
    },
    costPerHourFrom: {
      get() {
        return this.filters.costPerHourFrom;
      },
      set(value) {
        this.setFilter('costPerHourFrom', value);
      },
    },
    costPerHourTo: {
      get() {
        return this.filters.costPerHourTo;
      },
      set(value) {
        this.setFilter('costPerHourTo', value);
      },
    },
    experience: {
      get() {
        return this.filters.experience;
      },
      set(value) {
        this.setFilter('experience', value);
      },
    },
	name: {
      get() {
        return this.filters.name;
      },
      set(value) {
        this.setFilter('name', value);
      },
    },
    /**
     * @returns {SearchCandidatesFilters}
     */
    filters() {
      return this.$store.getters['events/searchFilters'];
    },
    gear: {
      get() {
        return this.filters.gears;
      },
      set(value) {
        this.setFilter('gears', value);
      },
    },
    languages: {
      get() {
        return this.filters.languages;
      },
      set(value) {
        this.setFilter('languages', value);
      },
    },
    rating: {
      get() {
        return this.filters.rating;
      },
      set(value) {
        this.setFilter('rating', value);
      },
    },
    skills: {
      get() {
        return this.filters.skills;
      },
      set(value) {
        this.setFilter('skills', value);
      },
    },
  },
  destroyed() {
	this.$store.commit('events/resetFilters');
  },
  methods: {
    /**
     * @returns {void}
     */
    onChange() {
      this.$emit('change');
    },
    /**
     * @param {keyof SearchCandidatesFilters} field
     * @param {any} value
     * @returns {void}
     */
    setFilter(field, value) {
      // #TODO this should be an action, which then calls a commit
      this.$store.commit('events/setFilter', { field, value, options: { toggle: true } });
    },
  },
};
</script>
